<style lang="less" scoped>
.number-control{
  display: flex;
  border-radius: 4.5px;
  border: 0.5px solid #9b9b9b;
  .add, .reduce{
    width: 43px;
    line-height: 30px;
    height: 30px;
    text-align: center;
    padding-top: 3px;
    img{
      width: 20px;
      height: 20px;
      margin: auto;
      // vertical-align: middle;
    }
  }
  .number{
    width: 60px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 16px;
    color: #4a4a4a;
    border-right:  0.5px solid #9b9b9b;
    border-left:  0.5px solid #9b9b9b;
  }
}
</style>
<template>
  <div class="number-control">
    <div class="reduce" @click="reduce">
      <img v-if="number<=limitMinNum" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAYAAADjVADoAAAAAXNSR0IArs4c6QAAAI9JREFUeAHt0zEOgDAIBdDWeB6O48G5kC4uHZp2MsQ8th8Y4CW0pggQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAwN8E+s5BmXnvzFWdiYjlnUfV5b/eC8QrDgLE+HznGKfpmnY0CBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgaICD9DIBGTxJSGTAAAAAElFTkSuQmCC" />
      <img v-else src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAYAAADjVADoAAAAAXNSR0IArs4c6QAAAJRJREFUeAHt07kNwCAMAEBAmTETZIYMwQzZFZo0FChUyIrOnZ/CPskpCQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAg8DeBvHJQq1dbmYs6k+/n884Sdfnde4F4xUGAGJ/vGNNZVs5ZR50AAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBCIKtABqegEZgMQQgoAAAAASUVORK5CYII=" />
    </div>
    <div class="number">{{number}}</div>
    <div class="add" @click="add">
      <img v-if="number>=limitMaxNum" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAYAAADjVADoAAAAAXNSR0IArs4c6QAAANhJREFUeAHt2EEKwjAUQMHqgXL/c/RCuunmQQrBLBQcdylEy/j6CzkOHwIECBAgQIAAgS2Bx9bujc3neb5m28cYX7mn5+xm/vEaiOtfBwGiA0ARilBEBRRRDzNCEYqogCLqYUYoQhEVUEQ9zAhFKKICiqjH0kHp3UFrv+p3VysHwoalR6MFK0IRiqjAtVp6a0x3bl68exOtTPjNn55uNyMuFhAg+oQoQhGKqIAi6mFGKEIRFVBEPcwIRSiiAoqohxmhCEVUQBH1MCPqYUWAAAECBAgQIPCpwBtACgxeBdWPawAAAABJRU5ErkJggg==" />
      <img v-else src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAYAAADjVADoAAAAAXNSR0IArs4c6QAAANtJREFUeAHt2EEKwjAUQMHWs3oGD+EZvGvddPMghWAWCo67FKJlfP2FbJsPAQIECBAgQIDAksC+tHth8/G8H6Pt++P1lXu6jW7mH6+BOP91ECA6ABShCEVUQBH1MCMUoYgKKKIeZoQiFFEBRdTDjFCEIiqgiHpMHZReHbT2q353NXMgbFh6NFqwIhShiAqcq6m3xnDn4sWrN9HMhF/86eF2M+JkAQGiT4giFKGICiiiHmaEIhRRAUXUw4xQhCIqoIh6mBGKUEQFFFEPM6IeVgQIECBAgAABAp8KvAG/iwxeLgIqSgAAAABJRU5ErkJggg==" />
    </div>
  </div>
</template>
<script>
import { Toast } from 'mint-ui'

export default {
  props: ['limitMaxNum', 'limitMinNum','initNum'],
  data() {
    return {
      number: this.initNum||1,
    }
  },
  methods: {
    add() {
      if (this.number >= this.limitMaxNum) {
        Toast({
          message: `每次最多购买${this.limitMaxNum}张`,
        })
        return
      }

      this.number ++
      this.$emit('num-add', this.number)
    },
    reduce() {
      if (this.number <= this.limitMinNum) {
        return
      }
      this.number --
      this.$emit('num-reduce', this.number)
    },
  },
  watch: {
    limitMinNum(newVal) {
      this.number = newVal
    },
  }
}
</script>
